import React from 'react';
import { Alert } from 'antd';
import useDismissibleBanner from '../hooks/useDismissibleBanner';

/**
 * Ant Design Alert that can be closed and stays dismissed via localStorage.
 */
export default function DismissibleAlert({ bannerKey, ...alertProps }) {
  const { dismissed, dismiss } = useDismissibleBanner(bannerKey);

  if (!bannerKey || dismissed) return null;

  return (
    <Alert
      {...alertProps}
      closable
      onClose={dismiss}
    />
  );
}
